import { Component, registerComponent, registerSystem, System } from "aframe";



interface OfflineAvatarComponent extends Component
{
	system : OfflineAvatarSystem;
	data  :{
		model : string;
		inventory : string;
	};
}
interface OfflineAvatarSystem extends System
{
	data : {
		template : string;
	};
}

registerSystem("offline-avatar", {
	schema : {
		template : { type : "string" }
		
	}
} );


registerComponent("offline-avatar", {
	schema : {
		model : { type : "string" },
		inventory : { type : "string" }
	},
	init(this : OfflineAvatarComponent)
	{
		this.el.addEventListener("template-loaded", () =>
		{
			const inventoryEl = this.el.querySelector("[avatar-inventory]")	 || this.el;
			inventoryEl.setAttribute("template__inventory", this.data.inventory);
		});
	},
	update(this: OfflineAvatarComponent)
	{
		this.el.setAttribute("template__offline-avatar", this.system.data.template);
		this.el.setAttribute("model-instance", { "model" : this.data.model } );
	}
});